import React, { useEffect } from 'react';
import { Skeleton } from 'antd';
import referralRewardGift from 'app/assets/images/referralRewardGift.png';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getReferralSummary } from 'app/store/reducers/referral.reducer';

/**
 * Rewards History banner (Figma 14513:16991 card layout, content per PM): total pesos
 * saved by spending Bitecoins across finished orders (`totalSpentBitecoins` from the
 * referral summary). Zero / missing → the "Start saving" empty state. Brown card with
 * the texts on the left and the gift artwork on the right.
 */
export const BitecoinSavingsBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { summary, summaryLoading } = useAppSelector((state) => state.referral);

  useEffect(() => {
    dispatch(getReferralSummary());
  }, []);

  if (summaryLoading && !summary) {
    return <Skeleton active paragraph={{ rows: 2 }} className="mb-6" />;
  }

  // Optional until `yarn models:build` regenerates the shared api types; ledger amounts are
  // integers already — Math.round is just defensive (peso amounts render without decimals).
  const totalSpent = Math.round(summary?.totalSpentBitecoins ?? 0);

  return (
    <div className="bitecoin-savings-banner mb-6">
      <div className="bitecoin-savings-banner__content">
        {totalSpent > 0 ? (
          <>
            <span className="bitecoin-savings-banner__title">You&apos;ve Saved</span>
            <span className="bitecoin-savings-banner__amount">{`P${totalSpent}`}</span>
            <span className="bitecoin-savings-banner__subtitle">by using your Bitecoins!</span>
            <span className="bitecoin-savings-banner__footnote">*estimated based on prices at the time of purchase.</span>
          </>
        ) : (
          <span className="bitecoin-savings-banner__title">Start saving with Bitecoins!</span>
        )}
      </div>
      <img className="bitecoin-savings-banner__gift" src={referralRewardGift} alt="gift" />
    </div>
  );
};
